export const BOT_USA_ADDRESS = {
  companyLogoUrl:
    "https://images.shirtly.com/image/upload/v1751569283/ConfluenceApp/EagleBeaverSports/Logos/EBS_NEW_LOGO_2024_jkjbjn.png",
  comapnyName: "Eagle Beaver Sports",
  addressLineOne: "Unit 1 - 780 Birchmount Road",
  city: "Scarborough",
  state: "ON",
  postalCode: "M1K 5H4",
  country: "CA",
  email: "customerservice@eaglebeaversports.com",
};

export const BOT_CA_ADDRESS = {
  companyLogoUrl:
    "https://images.shirtly.com/image/upload/v1751569283/ConfluenceApp/EagleBeaverSports/Logos/EBS_NEW_LOGO_2024_jkjbjn.png",
  comapnyName: "Eagle Beaver Sports",
  addressLineOne: "Unit 1 - 780 Birchmount Road",
  city: "Scarborough",
  state: "ON",
  postalCode: "M1K 5H4",
  country: "CA",
  email: "customerservice@eaglebeaversports.com",
};
